import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import type { ThankYouStepProps } from '@components/tenantStatus/onboardingWizard/types';

const ThankYouStep = ({ C, testID }: ThankYouStepProps) => {
  const bodyStyle = [
    font['Body'],
    { color: C('Label/Light/Tertiary'), textAlign: 'center' as const },
  ];
  return (
    <View testID={testID} style={{ alignItems: 'center' }}>
      <Text
        style={[
          font['Title 2'],
          { color: C('Label/Light/Primary'), textAlign: 'center', marginBottom: scale(8) },
        ]}
      >
        {i18n.t('Thank you!')}
      </Text>
      <Text style={bodyStyle}>{i18n.t("We're getting everything ready for you.")}</Text>
      <Text style={bodyStyle}>{i18n.t("You'll hear from us soon.")}</Text>
    </View>
  );
};

export default ThankYouStep;
